export const observerThreshold = 5; // 10

export const INTERSECTION_RATIO = 0.5; // not used apparently...
